import Cookies from "js-cookie";
import { BACKEND_URL, getHeaders, handleResponse } from "./utils";
import { TCommentCreate } from "../types/comment";

export async function getComments(id: number) {
  try {
    const response = await fetch(`${BACKEND_URL}/comments${id}`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get Coment:", error);
    throw error;
  }
}

export async function addComent(comment: TCommentCreate) {
  try {
    const response = await fetch(`${BACKEND_URL}/comments`, {
      method: "POST",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(comment),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get Coment:", error);
    throw error;
  }
}

export async function deleteComent(id: number) {
  try {
    const response = await fetch(`${BACKEND_URL}/comments/${id}`, {
      method: "DELETE",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error delete Coment:", error);
    throw error;
  }
}
